<template>
  <div class="myselect2">
    <div class="myselect2-container ion-activatable" @click="openModal">
      <span class="label">{{ selectedLabel }}</span>
      <ion-icon :icon="caretDown"></ion-icon>
      <ion-ripple-effect></ion-ripple-effect>
    </div>
  </div>
</template>


<style>
.myselect2modal .modal-wrapper{
  --background: transparent;
}
</style>

<style lang="css" scoped>
.myselect2-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 8px;
  border:1px solid #aaa;
  padding: 1vw 2vw;
  align-items: center;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
</style>

<script>
  import {
    IonIcon,
    IonRippleEffect,
    modalController,
  } from '@ionic/vue';
  import {
    caretDown,
  } from 'ionicons/icons';
  import { defineComponent, } from 'vue';
  import MySelect2Modal from './MySelect2Modal.vue';

  export default defineComponent({
    name: 'MySelect2',
    components: {
      IonIcon,
      IonRippleEffect,
    },
    props: {
      value: [String, Number],
      options: Object,
      title: {
        type: String,
        default: 'Vui lòng chọn',
      },
      rtl: {
        type: Boolean,
        default: false,
      },
      quick: {
        type: Boolean,
        default: false,
      },
      iconSize: {
        type: String,
        default: 'small',
      },
    },
    data() {
      return {
        modalShowed: false,
        selectedLabel: 'Chưa chọn',
        selectedValue: null,
      }
    },
    mounted() {
      Object.entries(this.options).forEach(entry => {
        const [value, label] = entry;
        if (this.value == value) {
          this.selectedValue = value;
          this.selectedLabel = label;
        }
      })
    },
    methods: {
      updateValue(newval) {
        this.$emit('change', newval);
        Object.entries(this.options).forEach(entry => {
          const [value, label] = entry;
          if (newval == value) {
            this.selectedLabel = label;
          }
        })
      },
      async openModal() {
        const modal = await modalController
          .create({
            component: MySelect2Modal,
            cssClass: 'myselect2modal modal-fullscreen',
            componentProps: {
              title: this.title,
              options: this.options,
              value: this.value,
              rtl: this.rtl,
              quick: this.quick,
              iconSize: this.iconSize,
            },
          });
        /* eslint-disable-next-line */
        modal.onWillDismiss().then((resp) => {
          console.log(resp.data);
          if (!resp.data.cancel) {
            this.updateValue(resp.data.value);
          }
        });

        return modal.present();
      },
    },
    setup() {
      return {
        caretDown,
      }
    }
  });
</script>
